import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import React, { useState } from "react";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { Box, Link, TextField } from "@mui/material";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { TextEditorActions } from "../TextEditorActions";
import { UIStandardLayer } from "../../../CommonUI/BuildlingBlocks/UIStandardLayer";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import { UISwitch } from "../../../CommonUI/BuildlingBlocks/UISwitch";
import { UIFontSelect } from "../../../CommonUI/BuildlingBlocks/UIFontSelect";
import { UIColorPickerTextField } from "../../../CommonUI/BuildlingBlocks/UIColorPickerTextField";
import { BaseTextMergeContainerElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { UIToggleButtons } from "../../../CommonUI/BuildlingBlocks/UIToggleButtons";

function RenderStyleButtons(props: { element: BaseTextMergeContainerElement }) {
    let [showStyles, setShowStyles] = useState<boolean>(false);
    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"end"}
        >
            <Link onClick={() => setShowStyles(true)}>Set Styles</Link>
            {showStyles && (
                <UIStandardLayer
                    open={showStyles}
                    title={"Edit Styles"}
                    primaryActionText={"Done"}
                    onPrimaryAction={() => setShowStyles(false)}
                    onClose={() => setShowStyles(false)}
                    renderUI={() => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                width={"400px"}
                            >
                                <ObserveState
                                    listenTo={props.element}
                                    control={() => {
                                        return (
                                            <>
                                                <Box
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Bold</UILabel>
                                                    <UISwitch
                                                        value={props.element.bold}
                                                        onChange={(e) => {
                                                            props.element.bold = e;
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Italic</UILabel>
                                                    <UISwitch
                                                        value={props.element.italic}
                                                        onChange={(e) => {
                                                            props.element.italic = e;
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Underline</UILabel>
                                                    <UISwitch
                                                        value={props.element.underline}
                                                        onChange={(e) => {
                                                            props.element.underline = e;
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Alignment</UILabel>
                                                    <UIToggleButtons
                                                        options={[
                                                            { value: "left" },
                                                            { value: "center" },
                                                            { value: "right" },
                                                        ]}
                                                        onChange={(e) => {
                                                            // @ts-ignore
                                                            props.element.alignment = e;
                                                        }}
                                                        value={props.element.alignment}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Paragraph Spacing</UILabel>
                                                    <TextField
                                                        type={"number"}
                                                        size={"small"}
                                                        value={props.element.margin}
                                                        onChange={(e) => {
                                                            props.element.margin = Number.parseInt(e.target.value);
                                                        }}
                                                    ></TextField>
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Font Size</UILabel>
                                                    <TextField
                                                        type={"number"}
                                                        size={"small"}
                                                        value={props.element.fontSize}
                                                        onChange={(e) => {
                                                            props.element.fontSize = Number.parseInt(e.target.value);
                                                        }}
                                                    ></TextField>
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Font</UILabel>
                                                    <UIFontSelect
                                                        selectedFont={props.element.fontName}
                                                        onChange={(f) => (props.element.fontName = f)}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Font Color</UILabel>
                                                    <UIColorPickerTextField
                                                        value={props.element.fontColor}
                                                        onChange={(c) => {
                                                            props.element.fontColor = c;
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    paddingTop={"10px"}
                                                    width={"100%"}
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                >
                                                    <UILabel>Background Color</UILabel>
                                                    <UIColorPickerTextField
                                                        value={props.element.backgroundColor}
                                                        onChange={(c) => {
                                                            props.element.backgroundColor = c;
                                                        }}
                                                    />
                                                </Box>
                                            </>
                                        );
                                    }}
                                />
                            </Box>
                        );
                    }}
                />
            )}
        </Box>
    );
}

export abstract class BaseTextMergeContainerEditor<
    T extends BaseTextMergeContainerElement,
> extends BaseTextMergeEditor<T> {
    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        let styles = this.editorData?.getStyles();
        return (
            <ObserveState
                listenTo={this.editorData}
                control={() => {
                    return this.renderContent(editContext, styles?.styleObject ?? {});
                }}
            />
        );
    }

    renderContent(editContext: TextMergeEditContext, styles: object): React.ReactNode {
        return <p style={styles}>{this.renderContentInternal(editContext)}</p>;
    }

    renderContentInternal(editContext: TextMergeEditContext) {
        return (
            <>
                {this.editorData?.elements.map((e) => {
                    let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                    return (
                        <ObserveState
                            key={e.id}
                            listenTo={e}
                            control={() => {
                                return editor?.renderDisplay(e, editContext);
                            }}
                        />
                    );
                })}
            </>
        );
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        let editor = TextEditorRegistration.getExpressionByTypeName(config.__type);
        return (
            <ObserveState
                key={config.id}
                listenTo={this.editorData}
                properties={["elements"]}
                control={() => {
                    return (
                        <Box
                            width={"100%"}
                            display={"flex"}
                            flexDirection={"row"}
                        >
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                paddingLeft={"5px"}
                                paddingTop={"5px"}
                                bgcolor={UIStyleConstants.GRAY_LIGHT_COLOR}
                                width={"40px"}
                                borderRadius="3pxpx"
                                border={
                                    editContext.selectedElement?.id === config.id ? "2px solid red" : "1px solid blue"
                                }
                                onClick={() => {
                                    editContext.setSelectedElement(config);
                                }}
                            >
                                <Box
                                    height={"30px"}
                                    width={"30px"}
                                >
                                    {editor?.editorPrototype.getIcon()}
                                </Box>
                            </Box>
                            <Box
                                marginTop={"10px"}
                                marginBottom={"5px"}
                                style={{ marginLeft: "-25px" }}
                                paddingTop={"10px"}
                                paddingBottom={"10px"}
                                width={"100%"}
                            >
                                {this.renderAbove(this.editorData as BaseTextMergeContainerElement, editContext)}
                                {this.editorData!.elements.map((e) => {
                                    let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                                    return (
                                        <div key={e.id + "editor"}>
                                            {editor?.renderEditor(e, editContext)}
                                            {editContext.selectedElement?.id === e.id && (
                                                <TextEditorActions editContext={editContext} />
                                            )}
                                        </div>
                                    );
                                })}

                                {this.editorData?.elements.length === 0 && (
                                    <Box
                                        display={"flex"}
                                        justifyContent={"center"}
                                    >
                                        [Empty]
                                    </Box>
                                )}

                                {this.renderBelow(this.editorData as BaseTextMergeContainerElement, editContext)}
                            </Box>
                        </Box>
                    );
                }}
            />
        );
    }

    renderAbove(element: BaseTextMergeContainerElement, _context: TextMergeEditContext): JSX.Element | undefined {
        return <RenderStyleButtons element={element} />;
    }

    renderBelow(_element: BaseTextMergeContainerElement, _context: TextMergeEditContext): JSX.Element | undefined {
        return undefined;
    }
}
